import { Icon } from '@livable/saas-react-components';
import { Button, Chip } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from 'src/stores';
import useStyles from './styles';
export default function TeamMemberBlock(_ref) {
  let id = _ref.id,
    type = _ref.type,
    _ref$status = _ref.status,
    status = _ref$status === void 0 ? '' : _ref$status,
    _ref$contactRole = _ref.contactRole,
    contactRole = _ref$contactRole === void 0 ? '' : _ref$contactRole,
    _ref$contactName = _ref.contactName,
    contactName = _ref$contactName === void 0 ? '' : _ref$contactName,
    contactEmail = _ref.contactEmail;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const handleRemove = contactId => {
    if (type === 'building') {
      store.addNewProperty.removeBuildingContacts(contactId);
    } else {
      store.addNewProperty.removeUtilitiesContacts(contactId);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.member
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.role
  }, contactRole), /*#__PURE__*/React.createElement("div", {
    className: classes.contact
  }, contactName), /*#__PURE__*/React.createElement("div", {
    className: classes.emailWrapper
  }, status === 'pending' && /*#__PURE__*/React.createElement(Chip, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "mail-send"
    }),
    variant: "warning",
    label: t('general.pending')
  }), status === 'active' && /*#__PURE__*/React.createElement(Chip, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "mail-success"
    }),
    variant: "success",
    label: t('general.active')
  }), /*#__PURE__*/React.createElement("span", {
    className: classes.email
  }, contactEmail)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    variant: "actionIcon",
    state: "white",
    onClick: () => handleRemove(id),
    className: classes.actionButton,
    'custom-attribute': '100-team-member-block'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "delete"
  }))));
}
TeamMemberBlock.propTypes = {
  contactRole: PropTypes.string,
  contactName: PropTypes.string,
  status: PropTypes.string,
  handleRemove: PropTypes.func
};